module.exports = __webpack_public_path__ + "static/btn_036.23662dd4.png";